import React, { useEffect, useState } from 'react';
import './SearchLayout.style.css';
import { CloseOutlined } from '@ant-design/icons';
import { Button, ScrollLayout, Search } from 'components';

import Up from 'assets/icon/up_icon.png';
import Down from 'assets/icon/down_icon.png';
import Keep from 'assets/icon/keep_icon.png';
import New from 'assets/icon/new_icon.png';
import Close from 'assets/icon/x_icon.png';
import MessageAlert, { deleteStorage, getStorage, setStorage } from 'utils';

const SearchLayout = ({ logo, onClose, recommend = [], popular = [] }) => {
  /* ===== Route ===== */
  /* ===== Props ===== */
  /* ===== State ===== */
  const [searchValue, setSearchValue] = useState('');
  const [recentList, setRecentList] = useState([]);

  /* ===== Hooks ===== */
  /* ===== Function ===== */
  const getIcons = (name = 'keep') => {
    const type = name.toLocaleUpperCase();

    return <img src={icons[type]} alt={name} />;
  };

  /**
   * 최근 검색어 삭제
   * --
   */
  const removeRecentSearch = (item) => {
    if (item) {
      const r = recentList?.filter((i) => i !== item);
      setRecentList(r);
      setStorage('jm_search_word', r);
    } else {
      setRecentList([]);
      deleteStorage('jm_search_word');
    }
  };

  /**
   * 검색
   * --
   */
  const handleSearch = () => {
    if (!searchValue) {
      MessageAlert.warning('검색어를 입력해주세요');
      return false;
    }

    /**
     * 최근 검색어 저장
     * --
     */
    const recentList = getStorage('jm_search_word') ?? [];
    const newList = recentList.reduce((acc, cur) => {
      if (cur === searchValue) return acc;
      else acc.push(cur);

      return acc;
    }, []);
    setStorage('jm_search_word', [searchValue, ...newList]);
    setRecentList([searchValue, ...newList]);

    // TODO: 검색로직 추가
  };

  /* ===== Variable ===== */
  const icons = {
    UP: Up,
    DOWN: Down,
    KEEP: Keep,
    NEW: New,
    CLOSE: Close,
  };

  /* ===== Hooks ===== */
  useEffect(() => {
    const recentArr = getStorage('jm_search_word');

    setRecentList(recentArr);
  }, []);

  /* ===== Render ===== */
  return (
    <div className="search_layout_wrapper">
      <div className="search_layout_container">
        <div className="search_layout_header">
          <div className="header_logo">{logo ? logo : 'Jmcoffee'}</div>
          <div>
            <button onClick={onClose}>
              <CloseOutlined />
            </button>
          </div>
        </div>

        <div className="search_content">
          <div className="search_content_input">
            <Search
              style={{ height: 70, paddingBottom: 8 }}
              size={32}
              value={searchValue}
              placeholder={'검색어를 입력해주세요'}
              onChange={(e) => setSearchValue(e)}
              onSearch={() => handleSearch()}
            />
          </div>

          <div className="recommend_search_word">
            <ScrollLayout direction="horizontal">
              {recommend.map((_item, _index) => (
                <Button
                  key={`item_button_${_index}`}
                  style={{
                    background: 'rgba(255, 255, 255, 0.5)',
                    marginRight: 8,
                    border: 'none',
                  }}
                  hovered
                  type="secondary"
                >
                  {_item.title}
                </Button>
              ))}
            </ScrollLayout>
          </div>

          <ul className="search_word_content">
            <li className="search_word_content_container">
              <div className="recent_search_word">
                <div className="recent_search_word_title">
                  <h5>최근 검색어</h5>
                  {recentList?.length ? (
                    <button onClick={() => removeRecentSearch()}>
                      전체삭제
                    </button>
                  ) : null}
                </div>

                <div className="recent_search_word_list">
                  {recentList?.slice(0, 10).map((_item, _index) => (
                    <div className="recent_search_word_item">
                      <p>{_item}</p>
                      <span onClick={() => removeRecentSearch(_item)}>
                        {getIcons('close')}
                      </span>
                    </div>
                  ))}
                </div>
              </div>
            </li>
            <li className="search_word_content_container">
              <div className="popular_search_word">
                <div className="recent_search_word_title">
                  <h5>인기 검색어</h5>
                </div>

                <div className="popular_search_word_list">
                  {popular
                    ?.sort((a, b) => a.order - b.order)
                    .map((_item, _index) => (
                      <div
                        key={`popular_${_index}`}
                        className="popular_search_word_item"
                      >
                        <p>
                          <span>{_item.order}</span>
                          {_item.title}
                        </p>
                        <span>{getIcons(_item.event)}</span>
                      </div>
                    ))}
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default SearchLayout;
